var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "channel-list" },
    [
      _c(
        "Search",
        _vm._g(_vm._b({}, "Search", _vm.filterAttrs, false), _vm.filterEvent)
      ),
      _c(
        "Table",
        _vm._g(
          _vm._b(
            {
              attrs: { "list-query-params": _vm.listQueryParams },
              on: {
                "update:listQueryParams": function ($event) {
                  _vm.listQueryParams = $event
                },
                "update:list-query-params": function ($event) {
                  _vm.listQueryParams = $event
                },
              },
            },
            "Table",
            _vm.tableAttrs,
            false
          ),
          _vm.tableEvent
        )
      ),
      _vm.dialogFormVisible
        ? _c(
            "el-dialog",
            {
              attrs: {
                title: _vm.title,
                visible: _vm.dialogFormVisible,
                width: "572px",
                top: "3vh",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.dialogFormVisible = $event
                },
              },
            },
            [
              _c("Detail", {
                ref: "getTable",
                attrs: {
                  title: _vm.title,
                  styleType: _vm.styleType,
                  tableData: _vm.dialogForm,
                  tableFormAttrs: _vm.dialogFormAttrs,
                  formLabelWidth: "92px",
                  isEdit: _vm.title === "编辑渠道",
                },
                on: {
                  resetSecret: _vm.resetSecret,
                  handleAvatarSuccess: _vm.handleAvatarSuccess,
                },
              }),
              _c(
                "div",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.dialogFormVisible = false
                        },
                      },
                    },
                    [_vm._v("取消")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.submitForm()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.buttonName))]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }